module.exports = __webpack_public_path__ + "img/female-factory-320w.d4be9db.jpeg";